﻿import * as Res from "./res";
import { dbfetch }  from "./dbfetch";
import { getApiConfig } from "./context";
import { createElement, unsafeSetHTML } from "./_dom";

async function loadHtml(url, options) {
	const response = await dbfetch(url, options);
	if (response.ok) {
		const ct = response.headers.get("Content-Type");
		if (/^text\/html(;|$)/.test(ct)) {
			const html = await response.text();
			return html;
		}
		return `Unexpected content: ${ct}`;
	} else {
		return `ERROR: ${response.status}: ${response.statusText}`;
	}
}

async function asyncActionRequest(url, data, signal, progress) {
	try {
		const params = new URLSearchParams(data);
		const html = await loadHtml(url + "&" + params.toString(), { signal });
		if (!html)
			return true;
		await unsafeSetHTML(progress.closest("form.fs-form"), html, "replace");
	} catch (e) {
		if (!signal.aborted) {
			progress.replaceWith(createElement("div", e.message));
		}
	}
	return false;
}

async function asyncAction(/**@type {HTMLElement}*/progress, { url, ids }) {
	const returnURL = new URLSearchParams(location.search).get("ReturnUrl") || getApiConfig("backUrl");
	const abortController = new AbortController();

	const progressMeter = progress.querySelector(".v3-progressbar");
	const progressValue = progress.querySelector(".v3-progressreport__progress .v3-progressbar__value");
	const progressMessage = progress.querySelector(".v3-progressreport__message");
	const cancelButton = progress.querySelector(".v3-progressreport__action");

	function back() {
		abortController.abort();
		cancelButton.disabled = true;
		progressMessage.replaceChildren("");
		if (returnURL) {
			var m = /[?#]/.exec(returnURL);
			var hostAndPath = returnURL.substring(0, m ? m.index : returnURL.length);
			if (hostAndPath.indexOf(':') < 0 || /^https?:/i.test(hostAndPath)) {
				location.replace(returnURL);
			}
		}
	}

	cancelButton.addEventListener("click", back);
	
	try {
		let success = true;
		progressMeter.style.setProperty("--v3-progress-value", 0);
		progressValue.replaceChildren("0%");
		for (let i = 0, j = 1, l = ids.length; success && i < l; i++, j++) {
			progressMessage.classList.add("ui-icon-spinner");
			progressMessage.replaceChildren(String.format(Res.getString("action.progress_text"), j, l));
			success &= await asyncActionRequest(url, { ids: ids[i] }, abortController.signal, progress);
			var p = (j / l * 100);
			progressMeter.style.setProperty("--v3-progress-value", p);
			progressValue.replaceChildren(p.toFixed(0) + "%");
		}
		progressMessage.classList.remove("ui-icon-spinner");
		if (success) {
			back();
		}
	} catch (e) {
		progressMessage.classList.remove("ui-icon-spinner");
		progressMessage.replaceChildren(e.toString());
	}
}

function init(ctx) {
	(ctx || document).querySelectorAll("[data-async-action]").forEach(el => asyncAction(el, JSON.parse(el.dataset.asyncAction)));
}

export { init };